export default __webpack_public_path__ + "static/media/chronopost-logo.3c48dbdc.png";